import { render } from "./CampaignCardItem.vue?vue&type=template&id=383e4c56&scoped=true"
import script from "./CampaignCardItem.vue?vue&type=script&lang=js"
export * from "./CampaignCardItem.vue?vue&type=script&lang=js"

import "./CampaignCardItem.vue?vue&type=style&index=0&id=383e4c56&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-383e4c56"]])

export default __exports__